import {
  enumsCashback,
  formatDate,
  useCampaignImage,
  useClientCampaign,
  ReplaceAllInstances,
} from '@itarget/shared'
import { Box, Icon, Typography } from '@material-ui/core'
import { useState } from 'react'
import Modal from '../Modal'
import { Actions } from './Actions'
import { useClasses } from './styles'
import { useTranslation } from './translation'

const Campaign = (props) => {
  const {
    campanha_id,
    data_fim,
    modificado_em,
    definicao,
    descricao,
    imagem,
    termo,
    aceite,
  } = props
  const translate = useTranslation()
  const [openTerms, setOpenTerms] = useState(false)
  const handleOpenTerms = () => setOpenTerms(true)
  const handleCloseTerms = () => setOpenTerms(false)
  const { getBannerImage, getThumbnailImage } = useCampaignImage({
    data: imagem,
  })
  const { data: clientCampaingResponse, registerClientCompany } =
    useClientCampaign()
  const {
    CAMPAIGN: { ADHERENCE },
  } = enumsCashback

  const banner = getBannerImage()
  const thumb = getThumbnailImage()
  const classes = useClasses()
  const today = new Date()
  const isActive = today.getTime() <= formatDate.parseISO(data_fim).getTime()
  const statusText = isActive ? translate.active : translate.expired
  const startEndPtBr = data_fim ? formatDate.ptBr(data_fim) : null
  const clientMembershipCampaign =
    clientCampaingResponse?.data?.client_membership_campaign
  const hasAdherence =
    (clientMembershipCampaign?.aceite || aceite) === ADHERENCE.ALLOWED
  const adherenceDateHour =
    clientMembershipCampaign?.modificado_em || modificado_em  
      ? formatDate.formatBrTimestamp(
          clientMembershipCampaign?.modificado_em || modificado_em,
        )
      : null
  const textAdherenceDateHour = ReplaceAllInstances(translate.adherenceAt, [
    adherenceDateHour,
  ])
  return (
    <>
      <Modal
        open={openTerms}
        handleClose={handleCloseTerms}
        title={descricao}
        image={banner}
        description={termo}
        definition={definicao}
      />
      <Box
        role="banner"
        data-testid="campaign"
        data-is-active={isActive}
        data-aceite={hasAdherence}
        className={classes.container}
        data-campanha-id={campanha_id}
      >
        {thumb ? (
          <img
            src={thumb}
            className={classes.image}
            alt="imagem da atividade"
          />
        ) : (
          <Box className={classes.noImage}>
            <Icon className={classes.imageIcon}>image</Icon>
          </Box>
        )}
        <Box className={classes.detailsContainer}>
          <Box className={classes.detailsHeader}>
            <Box className={classes.detailsHeaderTop}>
              <Box display="flex" alignItems="center">
                <Typography className={classes.title}>{descricao}</Typography>
                {hasAdherence && (
                  <Box marginLeft={1} className={classes.adherence}>
                    <Icon>check</Icon>
                    <Typography>{'Adesão confirmada'}</Typography>
                  </Box>
                )}
              </Box>
              <Typography className={classes.status}>{statusText}</Typography>
            </Box>
            <Box>
              <Typography className={classes.validity}>
                {`Válida até ${startEndPtBr}`}
              </Typography>
              {hasAdherence && (
                <Box
                  className={`${classes.actionDefaultStyle} ${classes.adherenceDate}`}
                >
                  <Icon>info</Icon>
                  <Typography>{textAdherenceDateHour}</Typography>
                </Box>
              )}
            </Box>
          </Box>
          {definicao && (
            <Typography className={classes.description}>
              {/* biome-ignore lint/security/noDangerouslySetInnerHtml: <É o modo mais recomendado para renderização de html com react. (Para melhorar a segurança, seguir https://barker.codes/blog/safely-rendering-html-in-react/)> */}
              <div dangerouslySetInnerHTML={{ __html: definicao }} />
            </Typography>
          )}
          <Actions
            {...props}
            clientMembershipCampaign={clientMembershipCampaign}
            registerClientCompany={registerClientCompany}
            handleOpenTerms={handleOpenTerms}
          />
        </Box>
      </Box>
    </>
  )
}

export default Campaign
